import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Styles = {
  box: { height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' },
};

const LoadingScreen = () => {
  return (
    <Box style={Styles.box}>
      <CircularProgress />
    </Box>
  );
};

export default LoadingScreen;
